import { Form, message } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  createCampaign,
  getCampaign,
  getListDomain,
  updateCampaign,
} from '../features/dashboard/actions';
import { isEmpty } from '../utils/helpers/helpers';

function useTextLink(props) {
  const [url, setUrl] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [aff_cid, setAff_cid] = useState('');
  const [listDomain, setListDomain] = useState([]);
  const location = useLocation();
  const [form] = Form.useForm();
  // const check = useDispatch("");
  useEffect(() => {
    fetListDomain();
    // eslint-disable-next-line
  }, []);
  const handleFetCampaignDetail = async (aff_cid) => {
    const { data } = await getCampaign(aff_cid);
    if (data.code === 200) {
      const dataRes = data?.data || {};
      setAff_cid(aff_cid);
      setIsEdit(true);
      setUrl(dataRes?.sharingContent);
      form.setFieldsValue({
        campaignName: dataRes.name || '',
        affiliationDomainId: dataRes.affiliationDomainId || '',
        specificLink: dataRes.specificLink || '',
        isCheckSpecificLink: !isEmpty(dataRes.specificLink),
      });
    }
  };
  useEffect(() => {
    if (!isEmpty(location.search)) {
      const search = location.search;
      const params = new URLSearchParams(search);
      const aff_cid = params.get('aff_cid');
      if (!isEmpty(aff_cid)) {
        handleFetCampaignDetail(aff_cid);
      }
    }
    // eslint-disable-next-line
  }, [props.generalInfo]);

  const fetListDomain = async () => {
    try {
      const { data } = await getListDomain();
      if (data.code === 200) {
        setListDomain(data?.data?.items || []);
        if (!isEmpty(data?.data?.items) && isEmpty(location.search)) {
          form.setFieldsValue({
            affiliationDomainId: data?.data?.items[0].id,
          });
        }
      }
    } catch (error) {}
  };

  const onFinish = async (values) => {
    try {
      let dataDTO = {
        affiliationType: 'link',
        campaignName: values.campaignName,
        affiliationDomainId: values.affiliationDomainId,
      };
      if (
        listDomain.find((el) => el.id === values.affiliationDomainId)
          ?.allowSpecificLink
      ) {
        if (values.isCheckSpecificLink) {
          dataDTO = { ...dataDTO, specificLink: values.specificLink };
        }
      }
      if (isEdit) {
        dataDTO = {
          ...dataDTO,
          id: aff_cid,
        };
      }
      let dataRes = {};
      if (isEdit) {
        const { data } = await updateCampaign(dataDTO);
        dataRes = data;
      } else {
        const { data } = await createCampaign(dataDTO);
        dataRes = data;
      }
      if (dataRes.code === 200) {
        setUrl(dataRes.data.sharingContent);
        message.success(
          `${isEdit ? 'Chỉnh sửa' : 'Tạo mới'} campaign thành công!`
        );
      } else {
        // message.error('Đã có lỗi xảy ra vui lòng thử lại sau');
        message.error(
          dataRes?.message || 'Đã có lỗi xảy ra vui lòng thử lại sau'
        );
      }
    } catch (error) {}
  };
  const onFinishFailed = (errorInfo) => {};
  return {
    onFinishFailed,
    onFinish,
    url,
    setUrl,
    listDomain,
    form,
  };
}

export default useTextLink;
